/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_AddInputs */

const th_player_add = /** @type {(inputs: Player_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เพิ่มบุตรหลาน`)
};

const en_player_add = /** @type {(inputs: Player_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add a child`)
};

const ja_player_add = /** @type {(inputs: Player_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`子どもを追加`)
};

const zh_player_add = /** @type {(inputs: Player_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`添加孩子`)
};

const es_player_add = /** @type {(inputs: Player_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Añadir un hijo o hija`)
};

const pt_player_add = /** @type {(inputs: Player_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar uma criança`)
};

const id_player_add = /** @type {(inputs: Player_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tambah anak`)
};

const fr_player_add = /** @type {(inputs: Player_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter un enfant`)
};

const tl_player_add = /** @type {(inputs: Player_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magdagdag ng bata`)
};

const vi_player_add = /** @type {(inputs: Player_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thêm một trẻ`)
};

const ko_player_add = /** @type {(inputs: Player_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아이 추가`)
};

const de_player_add = /** @type {(inputs: Player_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kind hinzufügen`)
};

const ru_player_add = /** @type {(inputs: Player_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Добавить ребёнка`)
};

const tr_player_add = /** @type {(inputs: Player_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Çocuk ekle`)
};

const it_player_add = /** @type {(inputs: Player_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungi un figlio`)
};

const pl_player_add = /** @type {(inputs: Player_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dodaj dziecko`)
};

const uk_player_add = /** @type {(inputs: Player_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Додати дитину`)
};

const hi_player_add = /** @type {(inputs: Player_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बच्चा जोड़ें`)
};

const ar_player_add = /** @type {(inputs: Player_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إضافة طفل`)
};

const ms_player_add = /** @type {(inputs: Player_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tambah anak`)
};

const bn_player_add = /** @type {(inputs: Player_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সন্তান যোগ করুন`)
};

const zh_tw2_player_add = /** @type {(inputs: Player_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新增孩子`)
};

const zh_hk2_player_add = /** @type {(inputs: Player_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新增孩子`)
};

const ur_player_add = /** @type {(inputs: Player_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بچہ شامل کریں`)
};

const fa_player_add = /** @type {(inputs: Player_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`افزودن فرزند`)
};

const sw_player_add = /** @type {(inputs: Player_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ongeza mtoto`)
};

const nl_player_add = /** @type {(inputs: Player_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kind toevoegen`)
};

/**
* | output |
* | --- |
* | "Add a child" |
*
* @param {Player_AddInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const player_add = /** @type {((inputs?: Player_AddInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_AddInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_player_add(inputs)
	if (locale === "ja") return ja_player_add(inputs)
	if (locale === "zh") return zh_player_add(inputs)
	if (locale === "es") return es_player_add(inputs)
	if (locale === "pt") return pt_player_add(inputs)
	if (locale === "id") return id_player_add(inputs)
	if (locale === "fr") return fr_player_add(inputs)
	if (locale === "tl") return tl_player_add(inputs)
	if (locale === "vi") return vi_player_add(inputs)
	if (locale === "ko") return ko_player_add(inputs)
	if (locale === "de") return de_player_add(inputs)
	if (locale === "ru") return ru_player_add(inputs)
	if (locale === "tr") return tr_player_add(inputs)
	if (locale === "it") return it_player_add(inputs)
	if (locale === "pl") return pl_player_add(inputs)
	if (locale === "uk") return uk_player_add(inputs)
	if (locale === "hi") return hi_player_add(inputs)
	if (locale === "ar") return ar_player_add(inputs)
	if (locale === "ms") return ms_player_add(inputs)
	if (locale === "bn") return bn_player_add(inputs)
	if (locale === "zh-TW") return zh_tw2_player_add(inputs)
	if (locale === "zh-HK") return zh_hk2_player_add(inputs)
	if (locale === "ur") return ur_player_add(inputs)
	if (locale === "fa") return fa_player_add(inputs)
	if (locale === "sw") return sw_player_add(inputs)
	if (locale === "nl") return nl_player_add(inputs)
	return en_player_add(inputs)
});